// extracted by mini-css-extract-plugin
export default {"wrapper":"errorPage_wrapper__kFhDC","icon":"errorPage_icon__TV2nT","mainText":"errorPage_mainText__T2afZ","subText":"errorPage_subText__hJKnY","link":"errorPage_link__SdPYL"};